/* eslint-disable react/require-default-props */
import React from 'react';
import { StatusTone } from 'services/ai_management_possible_competitors';
import { Badge } from './styles';

interface AiManagementStatusBadgeProps {
  tone: StatusTone;
  className?: string;
  children: React.ReactNode;
}

const AiManagementStatusBadge: React.FC<AiManagementStatusBadgeProps> = ({
  tone,
  className = '',
  children,
}) => (
  <Badge $tone={tone} className={`badge rounded ${className}`}>
    {children}
  </Badge>
);

export default AiManagementStatusBadge;
